import Vue from 'vue'
import Vuex from 'vuex'

import { getField, updateField } from 'vuex-map-fields';
import { doCalculation } from 'insurance-needs-engine';
import _ from "lodash";

import clientConfig from '../config/client';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    debugMode: false,
    acceptedDisclaimer: false,
    detailedExpenses: false,

    dependants: [{"Age": 0, "Amount": 3000, "Error": false}],
    debts: [{"Name":'', "Amount":0, "Error": false}],
    assets: [{"Name":'', "Amount":0, "Error": false}],
    expenses: [{"Name":'', "Amount":0, "Error": false}],

    data: {
      editAssumptions: {
        // edit assumption values
        wageInflation: 3.7,
        priceInflation: 2.5,
        retirementAge: 67,
        //TPD
        tpdRepayDebtsLiabilities: false,
        tpdFutureIncomeLevel: 100,
        tpdCeaseAllowanceForFutureIncomeAtAge: 65, // this needs to equal retirement age
        //Income protection
        incomeProtectionPaymentPeriod: 65,
        incomeProtectionPercentage: 70,
        incomeProtectionSuperGuarantee: 12,
        // life insurance
        lifeInsurancePaymentPeriod: 67,
        lifeInsuranceInvestmentReturn: 2.5,
      },
      stepData: {
        // about
        age: 45,
        familyType: "Single",
        // debt
        homeType: 'Mortgage',
        rentAmount: 0,
        mortgageAmount: 0,
        //income
        salaryYearly: 35000,
        salaryMonthly: 3000,
        salaryWeekly: 650,
        salaryPeriod: 'Year',
        savings: 0,
        // expenses
        expensesAmountPerMonth: 0,
        disabilityCost: 315000,
        funeralExpenses: 10000,
      },
    },

    Enum: {
      familyType: {
        SINGLE: "Single",
        COUPLE: "Couple",
        SINGLE_DEPENDANT: "Single_Dependant",
        COUPLE_DEPENDANT: "Couple_Dependant",
      },
      homeType: {
        MORTGAGE: "Mortgage",
        RENT: "Rent",
        NONE: "None",
      },
    },
    constants: {
      MAX_PERIOD: 13,
      MIN_PERIOD: 0,
      START_SCHOOL_AGE: 5,
      FINSIH_SCHOOL_AGE: 18,
      WEEKS_PER_YEAR: 52.14,
    },
    config: {
      livingExpenses: [
        {"value": "Fuel and power", "label": "Fuel and power"},
        {"value": "Food and drink", "label": "Food and drink"},
        {"value": "Clothing and footwear", "label": "Clothing and footwear"},
        {"value": "Medical and health expenses", "label": "Medical and health expenses"},
        {"value": "Insurance", "label": "Insurance"},
        {"value": "Telecommunications", "label": "Telecommunications"},
        {"value": "Transport", "label": "Transport"},
        {"value": "Recreation", "label": "Recreation"},
        {"value": "Other", "label": "Other"},
      ],
      debts: [
        {"value": "Investment loan", "label": "Investment loan"},
        {"value": "Personal loan", "label": "Personal loan"},
        {"value": "Car loan", "label": "Car loan"},
        {"value": "Credit card loan", "label": "Credit card loan"},
        {"value": "Other", "label": "Other"},
      ],
      assets: [
        {"value": "Super", "label": "Super"},
        {"value": "Term deposits", "label": "Term deposits"},
        {"value": "Managed funds", "label": "Managed funds"},
        {"value": "Shares", "label": "Shares"},
        {"value": "Investment property", "label": "Investment property"},
        {"value": "Other assets", "label": "Other assets"},
      ],
      fields: {
        // about
        age: { min: 18, max: 59 },
        dependantsAge: { min: 0, max: 18 },
        // debt
        rentAmount: { min: 0, max: 2000 },
        mortgageAmount: { min: 0, max: 5000000 },
        debts: { min: 0, max: 5000000 },
        // income
        salaryYearly: { min: 35000, max: 250000 },
        salaryMonthly: { min: 3000, max: 20000 },
        salaryWeekly: { min: 650, max: 5000 },
        savings: { min: 0, max: 5000000 },
        assets: { min: 0, max: 5000000 },
        // expenses
        expensesAmountPerMonth: { min: 0, max: 50000 },
        expenses:  { min: 0, max: 50000 },
        disabilityCost: { min: 0, max: 1000000 },
        funeralExpenses: { min: 0, max: 50000 },
        dependantAmount: { min: 0, max: 50000 },

        // edit assumptions
        inflation: { min: 0, max: 10 },
        investmentReturn: { min: 0, max: 10 },
        retirementAge: { min: 65, max: 70 },
        tpdFutureIncomeLevel: { min: 0, max: 100 },
        incomeProtectionPercentage: { min: 0, max: 70 },
        sgRate: { min: 12, max: 25 },
        lifeInsurancePaymentPeriod: { min: 0, max: 65 },
      }
    },
    formatOptions: {
      moneys: {
        numeral: true,
        numeralPositiveOnly: true,
        noImmediatePrefix: true,
        rawValueTrimPrefix: true,
        numeralIntegerScale: 7,
        numeralDecimalScale: 2,
        prefix: '$',
        signBeforePrefix: true
      },
      age: {
        numeral: true,
        numeralPositiveOnly: true,
        numeralIntegerScale: 2,
        numeralDecimalScale: 0
      },
      percentage: {
        numeral: true,
        numeralIntegerScale: 3,
        numeralDecimalScale: 2
      },
      years: {
        numeral: true,
        numeralPositiveOnly: true,
        numeralIntegerScale: 2,
        numeralDecimalScale: 0,
      }
    },
    engineResults: {}
  },
  mutations: {
    updateAcceptedDisclaimer(state, value) {
      state.acceptedDisclaimer = value;
    },
    updateDetailedExpenses(state, value) {
      state.detailedExpenses = value;
    },
    setLifeInsurancePaymentPeriod(state) {
      // set life insurance payment paeriod max retirnement age and min based on current age
      state.data.editAssumptions.lifeInsurancePaymentPeriod = state.data.editAssumptions.retirementAge;
      state.config.fields.lifeInsurancePaymentPeriod.max = state.config.fields.retirementAge.max;
      state.config.fields.lifeInsurancePaymentPeriod.min = state.config.fields.retirementAge.min;
    },
    settpdCeaseAllowanceForFutureIncomeAtAge(state) {
      state.data.editAssumptions.tpdCeaseAllowanceForFutureIncomeAtAge = state.data.editAssumptions.retirementAge;
    },
    setDefaultAssumptions(state) {
      // console.log("STORE: set default assumptions", clientConfig.defaults.editAssumptions);
      state.data.editAssumptions = _.cloneDeep(clientConfig.defaults.editAssumptions);

      // set life insurance payment paeriod max retirnement age and min based on current age
      state.config.fields.lifeInsurancePaymentPeriod.max = state.data.editAssumptions.retirementAge;
      state.config.fields.lifeInsurancePaymentPeriod.min = state.data.stepData.age ? state.data.stepData.age : 0 ;

      // set tpd cease allowance for future income at age based on retirement age. must be equal
      state.data.editAssumptions.tpdCeaseAllowanceForFutureIncomeAtAge = state.data.editAssumptions.retirementAge;
    },
    setDefaultData(state) {

      state.detailedExpenses = false;

      state.dependants = _.cloneDeep(clientConfig.defaults.dependants);
      state.debts = _.cloneDeep(clientConfig.defaults.debts);
      state.assets = _.cloneDeep(clientConfig.defaults.assets);
      state.expenses = _.cloneDeep(clientConfig.defaults.expenses);

      state.data.stepData = _.cloneDeep(clientConfig.defaults.stepData);

      if (clientConfig.defaults.fields) {
        state.config.fields = _.cloneDeep(clientConfig.defaults.fields);
      }
    },
    updateField,
  },
  actions: {
    getEngineResults() {
      var assetsArr = [];
      assetsArr = this.state.assets.slice(0);
      assetsArr.push({"Name": "Savings", "Amount": this.state.data.stepData.savings});

      // EXPENSES
      // work out education costs - per dependant
      var expArr = [];
      if(this.state.data.stepData.familyType === this.state.Enum.familyType.SINGLE_DEPENDANT || this.state.data.stepData.familyType === this.state.Enum.familyType.COUPLE_DEPENDANT) {
        this.state.dependants.forEach(dep => {
          var age = dep.Age;
          // calculate deferral period and payment period based on child's age
          var deferralPeriod = age < this.state.constants.START_SCHOOL_AGE + 1 ? this.state.constants.START_SCHOOL_AGE - age : this.state.constants.MIN_PERIOD;
          var paymentPeriod = age > this.state.constants.START_SCHOOL_AGE ? this.state.constants.FINSIH_SCHOOL_AGE - age : this.state.constants.MAX_PERIOD;
          var newDep = {
                    "Name": "Education costs",
                    "Cost_pa": dep.Amount,
                    "DeferralPeriod": deferralPeriod,
                    "PaymentPeriod": paymentPeriod,
                    "InflationRate_pa": this.state.data.editAssumptions.priceInflation / 100,
                    "InvestmentReturn_pa": this.state.data.editAssumptions.lifeInsuranceInvestmentReturn / 100
                  };
          expArr.push(newDep);
        });
      }

      // living expenses
      var livingExp = {};
      if(this.state.detailedExpenses) {
        // get list and sum the values
        var total = 0;
        this.state.expenses.forEach(expense => {
          total += expense.Amount;
        })
        livingExp = {
          "Name": "Living",
          "Cost_pa": total * 12,
          "DeferralPeriod": 0,
          "PaymentPeriod": this.state.data.editAssumptions.lifeInsurancePaymentPeriod - this.state.data.stepData.age,
          "InflationRate_pa": this.state.data.editAssumptions.priceInflation / 100,
          "InvestmentReturn_pa": this.state.data.editAssumptions.lifeInsuranceInvestmentReturn / 100
        };
      }
      else {
        // use amount per month val
        livingExp = {
          "Name": "Living",
          "Cost_pa": this.state.data.stepData.expensesAmountPerMonth * 12,
          "DeferralPeriod": 0,
          "PaymentPeriod": this.state.data.editAssumptions.lifeInsurancePaymentPeriod - this.state.data.stepData.age,
          "InflationRate_pa": this.state.data.editAssumptions.priceInflation / 100,
          "InvestmentReturn_pa": this.state.data.editAssumptions.lifeInsuranceInvestmentReturn / 100
        };
      }
      expArr.push(livingExp);

      // rent expenses
      if(this.state.data.stepData.homeType === this.state.Enum.homeType.RENT) {
        var rentExp = {
          "Name": "Rent",
          "Cost_pa": this.state.data.stepData.rentAmount * this.state.constants.WEEKS_PER_YEAR,
          "DeferralPeriod": 0,
          "PaymentPeriod": this.state.data.editAssumptions.lifeInsurancePaymentPeriod - this.state.data.stepData.age,
          "InflationRate_pa": this.state.data.editAssumptions.priceInflation / 100,
          "InvestmentReturn_pa": this.state.data.editAssumptions.lifeInsuranceInvestmentReturn / 100
        };
        expArr.push(rentExp);
      }

      // console.log(expArr);

      // mortgage
      var propertyArr = [];
      if(this.state.data.stepData.homeType === this.state.Enum.homeType.MORTGAGE) {
        propertyArr.push({
          "Name": "Main residence","MarketValue": 0,"Mortgage": this.state.data.stepData.mortgageAmount,
          "RepayMortgageWithLifeInsurance": true,"SellAndUseNetProceeds": false
        });
      }

      var obj = {
        "Age": this.state.data.stepData.age,
        "Salary":  this.state.data.stepData.salaryPeriod === "Month" ? this.state.data.stepData.salaryMonthly * 12 :
                    this.state.data.stepData.salaryPeriod === "Week" ? this.state.data.stepData.salaryWeekly * this.state.constants.WEEKS_PER_YEAR :
                    this.state.data.stepData.salaryYearly,
        "RetirementAge": this.state.data.editAssumptions.retirementAge,
        "LifeInsuranceInputs": {
        "ImmediateExpense": this.state.data.stepData.funeralExpenses,
        "ExistingCover": 0
        },
        "IncomeProtectionInputs": {
          "BenefitLevel_Income": this.state.data.editAssumptions.incomeProtectionPercentage / 100, // edit assumptions
          "BenefitLevel_Superannuation": this.state.data.editAssumptions.incomeProtectionSuperGuarantee / 100,
          "PaymentPeriod": this.state.data.editAssumptions.incomeProtectionPaymentPeriod, // comes from edit assupmtions
          "ExistingCover": 0,
          "MaximumCoverPerMonth": this.state.data.editAssumptions.MaximumCoverPerMonth
        },
        "TPDInputs":
        {
          "ImmediateExpense": this.state.data.stepData.disabilityCost, //  cost of disability
          "FutureIncomeLevel": this.state.data.editAssumptions.tpdFutureIncomeLevel / 100, // not config - need to expose in edit assumptions. min val: income protection benefit inome percentage. max val 100%
          "FutureIncomeRelativeToPreInjuryAfterTaxSalary": true, // dont need to expose
          "CeaseAllowanceForFutureIncomeAtAge": this.state.data.editAssumptions.tpdCeaseAllowanceForFutureIncomeAtAge, // we need to expose this in edit assumptions - default to retirement age
          "Inflation": this.state.data.editAssumptions.wageInflation / 100, // edit assumptions
          "InvestmentReturn": this.state.data.editAssumptions.lifeInsuranceInvestmentReturn / 100, // edit assumptions
          "ExistingCover": 0,
          "RepayDebtsLiabilities": this.state.data.editAssumptions.tpdRepayDebtsLiabilities  // edit assumptions TPD to include debt and liabilies
        },
        "Debts": this.state.debts,
        "Assets": assetsArr,
        "LifeInsuranceFutureExpenses": expArr,
        // the default payment period for living expenses.  default: min(10, retirementAge - currentAge). min: 0 - max: retirementAge - currentAge.
        "TPDFutureExpenses": [], // this was going to be used for homemaker - no longer required
        "Properties": propertyArr //we will use this for home with mortgage
      };
      console.log("data:", obj);
      var res = doCalculation(obj);
      console.log(res);
      this.state.engineResults = res;
    },
  },
  getters: {
    acceptedDisclaimer: state => {
      return state.acceptedDisclaimer;
    },
    familyType: state => {
      return state.familyType;
    },
    Enum: state => {
      return state.Enum;
    },
    data: state => {
      return state.data;
    },
    config: state => {
      return state.config;
    },
    detailedExpenses: state => {
      return state.detailedExpenses;
    },
    dependants: state => {
      return state.dependants;
    },
    debts: state => {
      return state.debts
    },
    expenses: state => {
      return state.expenses;
    },
    assets: state => {
      return state.assets;
    },
    engineResults: state => {
      return state.engineResults;
    },
    formatOptions: state => {
      return state.formatOptions;
    },
    editAssumptions: state => {
      return state.data.editAssumptions;
    },
    pageContent: () => {
      return clientConfig.content;
    },
    getField,
  }
})
